import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, CanActivateChild } from '@angular/router';
import { ConfigService } from '../Services/ConfigService';
import { EmployeeAuthGuard } from './EmployeeAuthGuard';

@Injectable()
export class LMSEmployeeAuthGuard extends EmployeeAuthGuard implements CanActivateChild {

	constructor(public configData: ConfigService, protected router: Router) {
		super(configData, router);
	}

	canLoad(route: Route) {
		return this.redirectIfNeeded((this.configData.isLMSCompany || this.configData.isMasterCompany) && super.canLoad(route));
	}

	canActivateChild(route: ActivatedRouteSnapshot): boolean {
		return this.canActivate(route);
	}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		return this.redirectIfNeeded((this.configData.isLMSCompany || this.configData.isMasterCompany) && super.canActivate(route));
	}

	redirectIfNeeded(isOk: boolean) {
		if (isOk) {
			return true;
		} else {
			this.router.navigate(['ang/Payment/NoLMS']);
			return false;
		}
	}
}